<template>
	<div>
		<j-base-multi-select-with-flexible-value
			:id="id"
			:options="options"
			:valuesVisibleOnLoad="this.valuesVisibleOnLoad"
			:value="value"
			:placeholder="placeholder ? placeholder : $t('search_name_code')"
			:allowLocalSearch="false"
			:allowMultiselect="allowMultiselect"
			:status="status"
			:size="size"
			valueKey="id"
			nameKey="name"
			@input="onInput($event)"
			@search="onSearch($event)"
		/>
	</div>
</template>

<script>
/**
 * This component is responsible for listing internals
 * @returns array of objects with selected internals
 */
import JBaseMultiSelectWithFlexibleValue from "@/components/JBaseMultiSelectWithFlexibleValue"
import api from "../api/"

export default {
	components: { JBaseMultiSelectWithFlexibleValue },
	props: {
		value: {
			validator(value) {
				return value === null || value instanceof Array
			},
			required: true,
			default: () => []
		},
		id: {
			type: String,
			required: false
		},
		status: {
			type: String,
			required: false
		},
		size: {
			type: String,
			required: false,
			default: "medium"
		},
		allowMultiselect: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: null
		},
		valuesVisibleOnLoad: {
			type: Boolean,
			default: false
		},

		/**
		 * When this is true, it will trigger search and prepopulate options menu with results but it will not open options menu
		 */
		prefetch: {
			type: Boolean,
			deafult: false
		}
	},

	data() {
		return {
			options: []
		}
	},

	methods: {
		onInput(value) {
			this.$emit("input", value)
		},

		async onSearch(searchTerm = null) {
			const where = searchTerm
				? {
						or: [{ name_contains: searchTerm }]
				  }
				: null
			const sort = { fieldName: "name", type: "asc" }

			let res = await api.internals({ sort, where })
			if (!res.errors) this.options = res.data.internals.list
		}
	},

	created() {
		if (this.valuesVisibleOnLoad === true) {
			this.onSearch("") // insert '' in multiselect search bar to trigger/return all values without typing anything
		}

		if (this.prefetch === true) this.onSearch("")
	}
}
</script>
